import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { API } from "../../utils/amplifyWrapper";
import { useGlobalStore } from "../../zustand-store/useGlobalStore";
import { addMixPanelEvent } from "../../store/actions";


export function useCreateBlankContent({ org_id }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const toggleUpgradeModal = useGlobalStore((state) => state.toggleUpgradeModal);

  return useCallback(async (integration_id, { audioProfile } = {}) => {
    try {
      const resp = await API.post(
        "main",
        `/organisation/${org_id}/integration/${integration_id}/content/v2`,
        {
          headers: { "Content-Type": "application/json" },
          body: {
            title: "Untitled audio",
            slate_value: [],
            composer_settings: [],
            is_draft: true,
            ...(audioProfile && { audioProfile }),
          },
        }
      );

      if (!resp.success && resp.failure_type === "NO_ENOUGH_AUDIOS") {
        dispatch(addMixPanelEvent({
          orgId: org_id, integrationId: integration_id, body: {
            eventName: "CREDIT_LIMIT_HIT",
            eventData: { failure_type: resp.failure_type },
          }
        }));
        history.replace(`/organisation/${org_id}/integration/${integration_id}/content`);
        toggleUpgradeModal(true, { title: resp.message, source: 'content_limit_reached', isManual: false });
        return;
      }

      if (!resp.success) {
        toast.error("Something went wrong!!");
        history.replace(`/organisation/${org_id}/integration/${integration_id}/content`);
        return;
      }

      // Invalidate organisation cache to refresh audios_count after content creation
      queryClient.invalidateQueries(["organisation", org_id]);

      history.replace(`/organisation/${org_id}/integration/${integration_id}/content/${resp.data.content_id}`);
    } catch (e) {
      console.log(e);
      toast.error("Something went wrong!!");
      history.replace(`/organisation/${org_id}/integration/${integration_id}/content`);
    }
  }, [org_id, history, queryClient, toggleUpgradeModal]);
}
